/// <amd-module name="TFS/Admin/Common/Util/NameValidator" />
import { equals } from "VSS/Core/Util/String";

// copied from Tfs/Service/WebAccess/Admin/Scripts/ProjectNameValidator.ts
// closely related to code in Tfs/Client/Core/CssUtils.cs

const _invalidProjectNames = [
    "server",
    "bin",
    "App_code",
    "App_Browsers",
    "App_Data",
    "App_GlobalResources",
    "App_LocalResources",
    "App_Themes",
    "App_WebReferences",
    "web.config",
    "SignalR"
];

const _invalidCssNodeNames = [
    "prn",
    "com1",
    "com2",
    "com3",
    "com4",
    "com5",
    "com6",
    "com7",
    "com8",
    "com9",
    "com10",
    "lpt1",
    "lpt2",
    "lpt3",
    "lpt4",
    "lpt5",
    "lpt6",
    "lpt7",
    "lpt8",
    "lpt9",
    "nul",
    "con",
    "aux",
    ".",
    ".."
];

const _invalidProjectCharacters = [
    "@",
    "~",
    ";",
    "{",
    "}",
    "'",
    "+",
    "=",
    ",",
    "<",
    ">",
    "|",
    "/",
    "\\",
    "?",
    ":",
    "&",
    "$",
    "*",
    '"',
    "#",
    "[",
    "]",
    "&",
    "%"
];

const _maxProjectLength = 64;
const _maxOrganizationLength = 50;

/**
 * Returns true if the given project name is valid.
 * @param projectName
 */
export function validateProjectName(projectName: string): boolean {
    let index = 0;

    // Account names must be 1 or more characters and cant start with
    // . or _
    // These are requirements from CssUtil.IsValidProjectName()
    if (
        projectName === null ||
        projectName.length === 0 ||
        projectName.length > _maxProjectLength ||
        projectName.substring(0, 1) === "_" ||
        projectName.substring(0, 1) === "." ||
        projectName.charAt(projectName.length - 1) === "."
    ) {
        return false;
    }

    // Check for invalid characters within the project name.
    for (index = 0; index < _invalidProjectCharacters.length; index++) {
        if (projectName.indexOf(_invalidProjectCharacters[index]) !== -1) {
            return false;
        }
    }

    const invalidNames = [..._invalidCssNodeNames, ..._invalidProjectNames];

    // Check for invalid css node names.
    for (index = 0; index < invalidNames.length; index++) {
        if (equals(projectName, invalidNames[index], true)) {
            return false;
        }
    }

    return true;
}

/**
 * Returns true if the given project name is valid.
 * @param organizationName
 */
export function validateOrganizationName(organizationName: string): boolean {
    let index = 0;

    // Account names must be 1 or more alphanumeric characters and cant start with
    // -
    // These are requirements from BusinessRulesValidator.ValidateNameCharacters()
    if (
        organizationName === null ||
        organizationName.length === 0 ||
        organizationName.length > _maxOrganizationLength ||
        organizationName.startsWith("-") ||
        organizationName.endsWith("-")
    ) {
        return false;
    }

    var letters = /^[0-9a-zA-Z-]+$/;
    if (organizationName.match(letters)) {
        return true;
    } else {
        return false;
    }
}
